<template>
	<tabbed-page-layout class="warehouse" title="Lager" :pages="pages" />
</template>

<script>
    export default {
		props: ['pages']
    }
</script>

<style lang="scss">

</style>